import styled from '@emotion/styled'

import { Flex } from './Flex'
import { Text } from './Text'
import { Color, theme } from '../constants'

const PieSlice = styled.div<{ percentage: number }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: conic-gradient(
    ${Color.BLUE} ${(props) => props.percentage}%,
    ${Color.MEDIUM_GREY} 0
  );
`

export const PieProgressbar = ({
  percentage,
  label,
}: {
  percentage: number
  label?: string
}) => {
  return (
    <Flex
      styles={{
        alignItems: 'center',
        justifyContent: 'space-between',
        width: label ? undefined : 58,
      }}
    >
      <Flex
        styles={{
          width: 20,
          height: 20,
        }}
      >
        <PieSlice percentage={percentage} />
      </Flex>
      <Text
        fontSize={13}
        fontWeight={theme.font.weight.legacy[600]}
        pl={label ? 1 : undefined}
      >
        {percentage.toFixed(0)}%{label ? ` ${label}` : ''}
      </Text>
    </Flex>
  )
}
